module.exports = __webpack_public_path__ + "static/media/5-b2.8c7d78b6.jpg";